import MUISyncIcon from '@mui/icons-material/Sync';

export const SyncIcon = MUISyncIcon;
